import { render, staticRenderFns } from "./CustomersManagement.vue?vue&type=template&id=53beb0ac&scoped=true"
import script from "./CustomersManagement.vue?vue&type=script&lang=js"
export * from "./CustomersManagement.vue?vue&type=script&lang=js"
import style0 from "./CustomersManagement.vue?vue&type=style&index=0&id=53beb0ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53beb0ac",
  null
  
)

export default component.exports